import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import SearchBar from '../../../../../shared/components/SearchBarNE/SearchBarNE';
import BdsButton from '../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import GenericMenu from '../../../../../shared/components/v3/GenericMenu/GenericMenu';
import { FILTER_IMAGES, REFRESH_IMAGE } from '../../../../../shared/constants/images';
import {
  REWARDS_ORDER_STATUS_FILTER,
  REWARDS_ORDER_STATUS_FILTERS_BY_TYPE
} from '../../../../../shared/constants/rewards';
import {
  CLICK_ACTION,
  ORDER_HISTORY_FILTER_DROPDOWN,
  ORDER_HISTORY_RELOAD
} from '../../../../../shared/constants/tagManager';
import { IUserCompany } from '../../../../../shared/interfaces/businessData';
import { IRewardsOrderFilters } from '../../../../../shared/interfaces/rewards';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_HISTORY } from '../../../../../shared/translations/rewards';
import { RewardsOrderTypesEnum } from '../../../../../shared/types/rewards';

import './RewardsHistoryFilter.scss';

interface RewardsHistoryFilterProps {
  loading: boolean;
  company: IUserCompany;
  selectedTab: RewardsOrderTypesEnum;
  ordersFilters: IRewardsOrderFilters;
  changeRewardsOrdersFilters: (ordersFilters: IRewardsOrderFilters) => void;
}

const RewardsHistoryFilter = ({
  loading,
  company,
  selectedTab,
  ordersFilters,
  changeRewardsOrdersFilters
}: RewardsHistoryFilterProps) => {
  const [showGenericMenu, setShowGenericMenu] = useState<boolean>(false);
  const { t } = useTranslation();

  const statusFilters = REWARDS_ORDER_STATUS_FILTERS_BY_TYPE[selectedTab];

  const statusOptions = statusFilters.map((statusFilter) => ({
    name: t(statusFilter.filter),
    value: statusFilter.filter
  }));

  const changeStatusFilter = (value: string) => {
    const statusFilter = statusFilters.find((option) => option.filter === value);
    if (!statusFilter) return;

    setShowGenericMenu(false);
    changeRewardsOrdersFilters({ ...ordersFilters, status: statusFilter });
    TagManagerService.pushEvent(CLICK_ACTION, ORDER_HISTORY_FILTER_DROPDOWN, {
      ...statusFilter.gtmTag,
      ...ordersFilters.type.gtmTag
    });
  };

  const onSearch = (searchValue: string) => {
    changeRewardsOrdersFilters({ ...ordersFilters, searchValue: searchValue });
  };

  const handleRefreshButtonClick = () => {
    changeRewardsOrdersFilters({ ...ordersFilters });
    TagManagerService.pushEvent(CLICK_ACTION, ORDER_HISTORY_RELOAD);
  };

  const handleGenericMenu = () => {
    setShowGenericMenu(!showGenericMenu);
  };

  return (
    <div className="rewards-history-filter">
      <SearchBar onSearch={onSearch} placeholder={t(TRANSLATION_HISTORY.table.searchPlaceholder)} />
      <div className="filter-button-container">
        <BdsButton
          action={handleRefreshButtonClick}
          variant="secondary"
          size="m"
          iconLeft={REFRESH_IMAGE}
          disabled={loading}
        >
          {t(TRANSLATION_HISTORY.table.refresh)}
        </BdsButton>
        <BdsButton action={handleGenericMenu} variant="secondary" size="m" iconLeft={FILTER_IMAGES} disabled={loading}>
          {t(TRANSLATION_HISTORY.filterButton)}
        </BdsButton>
        <GenericMenu
          key={selectedTab}
          setShowGenericMenu={setShowGenericMenu}
          showGenericMenu={showGenericMenu}
          title={t(TRANSLATION_HISTORY.filterButton)}
          company={company}
          type="custom"
          className="rewards-history-generic-menu"
          customData={{
            showButtonFilter: true,
            defaultValueOnFilterButton: true,
            typeCheckbox: 'square',
            data: statusOptions,
            onChanged: changeStatusFilter,
            value: REWARDS_ORDER_STATUS_FILTER.all.filter
          }}
        />
      </div>
    </div>
  );
};

export default RewardsHistoryFilter;
